import { ComponentProps, ReactNode } from "react";
import StyledReactModal from "styled-react-modal";
import { ModalContextProvider } from "./ModalContext";
import { Title, Content, Actions, CloseButton } from "./components";
import { alpha } from "../../typography";
import "../../designTokens/variables.css";

type StyledReactModalDefault = {
  default: typeof StyledReactModal;
};

const getStyledReactModal = () => {
  if (Object.keys(StyledReactModal).includes("default")) {
    return (StyledReactModal as unknown as StyledReactModalDefault).default;
  }
  return StyledReactModal;
};

const StyledModal = getStyledReactModal().styled`
    display: flex;
    flex-direction: column;
    min-width: 500px;
    max-width: 80vw;
    max-height: 80vh;
    overflow: hidden;
    padding: 16px 0px;
    background-color: var(--color-neutral-000-full);
    box-shadow: var(--elevation-8);
    border-radius: var(--size-border-radius-medium);
    ${alpha.primaryActive.body3};
    > * {
        margin-bottom: 8px;
        padding: 0px 16px;
        :last-child {
            margin-bottom: 0px;
        }
    }
`;

type BaseModalProps = ComponentProps<typeof StyledReactModal>;

export enum LegacyModalTestIds {
  Container = "legacy-modal",
}

type ModalProps = {
  afterClose?: BaseModalProps["afterClose"];
  afterOpen?: BaseModalProps["afterOpen"];
  beforeClose?: BaseModalProps["beforeClose"];
  beforeOpen?: BaseModalProps["beforeOpen"];
  isOpen: boolean;
  disableBackgroundClick?: boolean;
  onClose: () => void;
  children: ReactNode;
  id?: string;
  testId?: string;
  className?: string;
};

export const LegacyModal = ({
  isOpen,
  onClose,
  children,
  className,
  testId,
  id,
  disableBackgroundClick,
  ...modalProps
}: ModalProps) => {
  return (
    <ModalContextProvider value={{ onClose }}>
      <StyledModal
        isOpen={isOpen}
        {...(!disableBackgroundClick && { onBackgroundClick: onClose })}
        onEscapeKeydown={onClose}
        // @ts-expect-error ts(2769) library styled-react-modal doesn't expect className but it still works
        className={className}
        data-testid={testId ?? LegacyModalTestIds.Container}
        id={id}
        {...modalProps}
      >
        {children}
      </StyledModal>
    </ModalContextProvider>
  );
};

LegacyModal.Title = Title;
LegacyModal.Content = Content;
LegacyModal.Actions = Actions;
LegacyModal.CloseButton = CloseButton;
